module.exports = __webpack_public_path__ + "static/img/H3C.40330260.jpg";